export const AUTOCOMPLETE_RESULT_PLACEHOLDER =
  "Merci d'entrer au moins 3 caractères";
export const SEARCHBAR_PLACEHOLDER = 'Rechercher un podcast';
export const PLAYLIST_LABEL_FORM = 'PLAYLIST';
export const TRACKING_LABEL_FORM = 'LIEN DE TRACKING';
